import gsap from "gsap";

export default class ScrollSpy {
    constructor() {
        this.sidebarList = document.querySelector(".js-sidebar-list");
        this.winHeight = window.innerHeight;

        this.sidebarNav = document.querySelector(".js-sidebar-nav");
        this.sectionTitle = document.querySelectorAll(".js-post-section-title");

        if (this.sidebarNav && this.sectionTitle.length > 0) {
            this.init();
        }
    }

    /**
     * add wrappers and event on window
     */
    init() {
        this.sectionTitle.forEach((element) => {
            const navItem = document.createElement("li");
            navItem.classList.add("js-sidebar-list-item");

            const titleString = element.innerHTML;
            const title = document.createElement("p");
            const titleText = document.createTextNode(titleString);

            title.appendChild(titleText);
            navItem.appendChild(title);

            this.sidebarList.appendChild(navItem);

            title.addEventListener("click", () => {
                this.scrollSection(element);
            });
        });

        let sidebarItems = document.querySelectorAll(".js-sidebar-list-item");
        this.checkScroll(sidebarItems);

        window.addEventListener("scroll", () => {
            this.checkScroll(sidebarItems);
        });
    }

    /**
     * scroll to section
     * @param element
     */
    scrollSection(element) {
        gsap.to(document.documentElement, {
            scrollTop: -document.body.getBoundingClientRect().y + element.getBoundingClientRect().y - 100,
            ease: "power3.inOut",
            duration: 1,
        });
    }

    /**
     * scroll spy core
     * @param sidebarItems
     */
    checkScroll(sidebarItems) {
        this.sectionTitle.forEach((section, index) => {
            let nextSection = null;
            let nextSectionPos = 99999;
            let sectionPos = section.getBoundingClientRect().top;

            if (index < this.sectionTitle.length - 1) {
                nextSection = this.sectionTitle[index + 1];
                nextSectionPos = nextSection.getBoundingClientRect().top;
            }

            section.classList.remove("is-active");
            sidebarItems[index].classList.remove("is-active");

            if (sectionPos < this.winHeight * 0.7 && nextSectionPos > this.winHeight * 0.7) {
                section.classList.add("is-active");
                sidebarItems[index].classList.add("is-active");
            }
        });
    }
}
